export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
export function copyArray2D(array) {
    return array.map(function (inner) { return inner.map(function (x) { return x; }); });
}
export function copyArray1D(array) {
    return array.map(function (x) { return x; });
}
//# sourceMappingURL=deepCopy.js.map